import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import Swal from "sweetalert2";
import "./ForPass.css";

type ResetPasswordResponse = {
  status_code: number;
  message?: string;
};

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mobile = location.state?.mobile || "";
  const token = location.state?.token || "";

  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (!mobile || !token) {
    navigate("/login");
    return null;
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      Swal.fire("Error!", "Password must be at least 6 characters.", "error");
      return;
    }
    setLoading(true);
    try {
      const res = await WebService.postAPI({
        action: "/v1/door-management/reset-password",
        body: {
          mobile_number: mobile,
          new_password: newPassword,
          token: token,
        }
      }) as ResetPasswordResponse;
      if (res.status_code === 200) {
        Swal.fire({
          title: "Success!",
          text: "Password reset successful. Please login.",
          icon: "success",
          timer: 2500,
          showConfirmButton: false,
          timerProgressBar: true,
          willClose: () => {
            navigate("/login");
          }
        });
      } else {
        Swal.fire("Error!", res.message || "Failed to reset password.", "error");
      }
    } catch {
      Swal.fire("Error!", "Network error. Please try again.", "error");
    }
    setLoading(false);
  };

return (
  <div
    className="login-bg"
    style={{
      background: `url(${process.env.PUBLIC_URL}/login.png) no-repeat left center/cover`,
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    }}
  >
    <form
      className="login-float-form"
      style={{ width: 380, maxWidth: "90vw" }}
      onSubmit={handleSubmit}
      noValidate
    >
      <img src="/Assets/dm.png" alt="Logo" className="login-logo" />
      <h2 className="login-heading" style={{ marginBottom: 8 }}>
        Reset Password
      </h2>
      <input
        type="password"
        className="login-input"
        placeholder="Enter new password"
        value={newPassword}
        onChange={e => setNewPassword(e.target.value)}
        minLength={6}
        required
        disabled={loading}
        style={{ marginBottom: 14 }}
      />
    
      <button className="login-btn" type="submit" disabled={loading}>
        {loading ? "Resetting..." : "Reset Password"}
      </button>
      <div style={{ marginTop: 22, width: "100%", textAlign: "left" }}>
        <a href="/login" className="login-register-link">Back to Login</a>
      </div>
    </form>
  </div>
);

};

export default ResetPassword;
